<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  Импэкснефтехим — независимый нефтехимический трейдер,
                  осуществляющий комплексные поставки углеводородного сырья,
                  продуктов переработки нефти, химической и нефтехимической
                  продукции.
                </p>

                <p>
                  Импэкснефтехим — основное подразделение многопрофильного
                  холдинга, ведущего как коммерческую, так и инвестиционную
                  деятельность Компания работает на рынке с 2002 года и
                  осуществляет свою деятельность как на внутреннем, так и на
                  внешних рынках.
                </p>
                <p>
                  За время работы на рынке компанией установлены прямые
                  партнерские отношения практически со всеми крупными
                  нефтехимическими компаниями России и ближнего зарубежья.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+74952879690"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (495) 287-96-90</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:info@mccc.ru"
                          class="ViewPromo__advantage-contact-link"
                          >info@mccc.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «Импэкснефтехим»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1300,
    productId: 2142,
    name: 'ООО «Импэкснефтехим»',
    inn: '7730160881 ',
  }),
};
</script>
